import { useState, useCallback } from "react";
import { useLocalStorage } from "./useLocalStorage";
import { disconnectSocket } from "../service/socketio";


export const useUser = () => {

	const [user, setUser] = useState(null);
	//console.log("user", user)
	const [token, setToken] = useState(null);
	//console.log("TOKEN", token)
	const [role, setRole] = useState(null);
	const [userId, setUserId] = useState(null);
	const [roles, setRoles] = useState(null); //multi-rol (074): lista completa
	//console.log("ROLE", role)

	//const prueba = "pruebaA" //#comentar 18ENE25
	const { setItem, removeItem } = useLocalStorage();

	//const addUser = (user, token, role = 'user') => {
	// useCallback: identidad estable para que login() no re-dispare el chequeo
	// de authContext en cada render (ver useLocalStorage.js y authContext.jsx).
	const addUser = useCallback((user, token, role, userId, roles) => {
		//const userData = typeof user === 'string' ? { name: user, role } : { ...user, role };
		//setUser(userData);
		
		setUser(user);
		setToken(token);
		setRole(role);
		setUserId(userId);
		setRoles(roles);

		setItem("user", user ? JSON.stringify(user) : '');
		setItem("token", token ? JSON.stringify(token) : '');
		setItem("role", role ? JSON.stringify(role) : '');
		setItem("userId", userId ? JSON.stringify(userId) : '');
		setItem("roles", roles ? JSON.stringify(roles) : '');
	}, [setItem]);

	const removeUser = useCallback(() => {
		setUser(null);
		removeItem("user");
		removeItem("token");
		removeItem("role");
		removeItem("userId");
		removeItem("roles"); //multi-rol (074)
		// Cierra el socket: el handshake lleva el token del usuario que se va, y
		// si el socket siguiera vivo el backend lo seguiría tomando por ese
		// usuario (historial y salas del chat de soporte).
		try { disconnectSocket(); } catch (e) { }
	}, [removeItem]);
	return { user, addUser, removeUser, token, role, roles, userId }; //prueba,
};